export enum StripeInitEnum {
  MISSING_PLAN = "Missing plan selection",
  INCOMPLETE_SUBSCRIPTION = "Subscription is incomplete",
  SUBSCRIPTION_EXPIRED = "Subscription expired",
}
